export default __webpack_public_path__ + "static/media/AdCave_02.20b5f345.png";